import React, { useState, useEffect } from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import isMobile from 'ismobilejs'
import { scroller } from 'react-scroll'
import {
  Container,
  TextBody,
  BlockingLoader,
  TextTitle,
  ToastContext,
  Button,
  Icon,
  Css,
  Sticky,
  Icon64,
  TextCaption
} from '@pmi/pmi-iqos-ds-react'
import {
  analytics,
  localstorage,
  constants,
  cookie,
  buildCartState,
  updateCartCounter,
  mapBundleListForDisplay,
  mapProductListForDisplay,
  getToastMessagesFromResponse,
  getToastMessagesFromError,
  isAuthenticated,
  checkStockNotification,
  isPurchaseLimitationsErrorCode,
  isCartPurchaseLimitationsErrorCode,
  extractErrorCode,
  checkLoginWarnings,
  parseTranslations,
  htmlTranslation,
  resetGrecaptcha,
  dispatchPopupPromotionAlreadyUsed,
  PublishedComponent,
  goTo,
  Routes,
  CommonTranslations,
  canUseDOM
} from '@pmi/pmi-iqos-shared-react'
import {
  CartCheckoutGuestActions,
  CartItem,
  CartSummary,
  ModalNotifyMe,
  ProductBundleModal,
  ProductListCrossSell,
  ProductListUpSell
} from '@dcx-common/components'
import { DcxApiManager } from '@dcx-common/services'
import CartTranslations from './cart.json'

const componentContainerId = 'dcx-cart'
const stickySummaryElementId = 'dcx-sticky-cart-summary'
const ANALYTICS_LIST_NAME = 'Recommended (Cart)'
const ANALYTICS_LIST_NAME_UPSELL = 'Upsell'
const carttype = 'QURE'

const CartComponent = ({
  translations,
  logError,
  backButtonBlockId,
  isUpgrade,
  bundleDetailPath,
  line
}) => {
  const [cartItems, setCartItems] = useState([])
  const [subtotal, setSubtotal] = useState('')
  const [total, setTotal] = useState('')
  const [discount, setDiscount] = useState('')
  const [delivery, setDelivery] = useState('')
  const [totalItems, setTotalItems] = useState(0)
  const [loading, setLoading] = useState(true)
  const [blockingLoading, setBlockingLoading] = useState(false)
  const [crossSell, setCrossSell] = useState([])
  const [upSell, setUpSell] = useState([])
  const [showBundleModal, setShowBundleModal] = useState(false)
  const [modalBundle, setModalBundle] = useState(null)
  const [promotions, setPromotions] = useState(null)
  const [couponCode, setCouponCode] = useState('')
  const [eligibleCoupons, setEligibleCoupons] = useState([])
  const [stickySummaryVisible, setStickySummaryVisible] = useState(false)
  const [stickySummaryLayout, setStickySummaryLayout] = useState({})
  const [loadingRelatedProducts, setLoadingRelatedProducts] = useState(false)
  const [sampleSelectionAlertTriggered, setSampleSelectionAlertTriggered] =
    useState(false)
  const [modalNotifyMe, setModalNotifyMe] = useState({
    key: 0,
    open: false,
    product: null,
    selectedOptionIndex: 0,
    isAuthenticated: false,
    email: undefined,
    name: undefined
  })
  const [hasDiscount, setHasDiscount] = useState(false)
  const [discountFlat, setDiscountFlat] = useState(null)
  const [deliveryFlat, setDeliveryFlat] = useState(null)
  const [hideCoupon, setHideCoupon] = useState(isUpgrade)
  const [tvaStatus, setTvaStatus] = useState('')
  const [coupons, setCoupons] = useState([])
  const [familyNotice, setFamilyNotice] = useState(null)
  const [noAuthFreeSampleMessage, setNoAuthFreeSampleMessage] = useState('')
  const [familyWarning, setFamilyWarning] = useState(false)
  const [addCouponError, setAddCouponError] = useState(false)
  const [samplePresenceAlreadyTriggered, setSamplePresenceAlreadyTriggered] =
    useState(false)

  const toastContext = ToastContext.getContextActions()
  const popupToast = toastContext.popupToast
  const dismissToast = toastContext.dismissToast
  const couponSection = 'coupon-section'

  const api = new DcxApiManager(line)

  useEffect(() => {
    api.setErrorTranslations(translations)
    loadData()
  }, [])

  useEffect(() => {
    if (noAuthFreeSampleMessage) {
      analytics.samplingCart('Display', 'Pre - Pop-up - Apply free sampling')
    }
  }, [noAuthFreeSampleMessage])

  useEffect(() => {
    if (
      !samplePresenceAlreadyTriggered &&
      cartItems &&
      cartItems.length > 0 &&
      cartItems.filter(item => item.products[0].isSample).length > 0
    ) {
      analytics.samplingCart('Display', 'Tobacco Pack')
      setSamplePresenceAlreadyTriggered(true)
    }
  }, [cartItems])

  const listenLoginSuccessEvent = (kill = false) => {
    const e = constants.REACT_LOGIN_SUCCESS_EVENT
    const f = loadData
    if (kill) {
      window.removeEventListener(e, f)
    } else {
      window.addEventListener(e, f)
    }
  }

  useEffect(() => {
    if (!isUpgrade) {
      listenLoginSuccessEvent()
      return () => {
        listenLoginSuccessEvent(true)
      }
    }
  }, [listenLoginSuccessEvent])

  const loadData = async () => {
    isUpgrade && (await checkUpgradeFlow())
    await getCart()
    getRelatedProducts()
    !isUpgrade && analyticsProductListImpression()
    !isUpgrade && checkCoupons()
    checkWarnings()
  }

  const checkWarnings = () => {
    checkLoginWarnings(
      localstorage,
      analytics,
      translations,
      popupToast,
      ToastContext
    )
  }

  const checkOcrSkip = res => {
    const showSkipedOcr = cookie.get(constants.COOKIE_SHOW_SKIPPED_TOAST)
    cookie.remove(constants.COOKIE_SHOW_SKIPPED_TOAST)
    const thresholdFailed = res.sagawaThresholdFailed
    let title = ''
    let message = ''
    if (showSkipedOcr && !thresholdFailed) {
      title = translations.tk_ocrRequiredTitle
      message = translations.tk_ocrRequiredMessage
    } else if (showSkipedOcr && thresholdFailed) {
      title = translations.tk_ocrCartAmountNotReachedTitle
      message = translations.tk_ocrCartAmountNotReachedMessage
    }
    title &&
      message &&
      popupToast({
        type: ToastContext.types.error,
        title: title,
        content: message,
        actions: [
          <Button
            key={0}
            variant={Button.variants.secondary}
            text={translations.tk_ocrButton}
            onClickHandler={() => {
              goTo(Routes.conversion, false, false, [
                `callredirectUrl=${Routes.checkout}`,
                `skipredirectUrl=${Routes.cart}`
              ])
            }}
            data-testing="Cart_Button_OCR"
          />
        ]
      })
  }

  const analyticsProductListImpression = () => {
    if (crossSell && crossSell.length) {
      analytics.productListImpression(crossSell, ANALYTICS_LIST_NAME)
    }
    if (upSell && upSell.length) {
      analytics.productListImpression(upSell, ANALYTICS_LIST_NAME)
    }
  }

  const checkCoupons = async () => {
    const coupon = localstorage.get('coupon')
    if (coupon) {
      if (isAuthenticated()) {
        localstorage.remove('coupon')
        handleCouponAction('add', null, coupon)
      } else {
        popupToast({
          type: ToastContext.types.error,
          title: translations.tk_errorApplyingCoupon,
          content: translations.tk_couponLoggedOffLabel,
          actions: cartToastActions()
        })
      }
    }
  }

  const checkUpgradeFlow = async () => {
    const flag = Boolean(cookie.getUpgradeFlowFlag())
    if (!flag) {
      await api.cart.removeFromCart(null, carttype)
    }
  }

  const setCartState = cartState => {
    setCartItems(cartState.cartItems)
    setTotalItems(cartState.totalItems)
    setSubtotal(cartState.subtotal)
    setTotal(cartState.total)
    setHasDiscount(cartState.hasDiscount)
    setDiscount(cartState.discount)
    setDelivery(cartState.delivery)
    setDiscountFlat(cartState.discountFlat)
    setDeliveryFlat(cartState.deliveryFlat)
    setTvaStatus(cartState.tvaStatus)
    setPromotions(cartState.promotions)
    setNoAuthFreeSampleMessage(cartState.noAuthFreeSampleMessage)
    !isUpgrade && setHideCoupon(cartState.hideCoupon)
    !isUpgrade && setCoupons(cartState.coupons)
    !isUpgrade && setFamilyNotice(cartState.familyNotice)
    !isUpgrade && setEligibleCoupons(cartState.eligibleCoupons)
  }

  const getCart = async () => {
    try {
      const res = await api.cart.getCart({
        ...(isUpgrade && { params: { carttype } })
      })
      const { ...cart } = res
      updateCartCounter(cart.amount)
      const cartState = buildCartState(cart)
      !isUpgrade &&
        cartState.familyNotice &&
        analytics.productFamilyConflict(true)
      setLoading(false)
      setBlockingLoading(false)
      if (!isUpgrade && cartState.hasFullDiscountCoupon) {
        popupToast({
          type: ToastContext.types.none,
          subtitle: translations.tk_fullDiscountCouponWarning
        })
      }
      dispatchPopupPromotionAlreadyUsed(
        cookie.getSpiceId(),
        cartState,
        popupToast,
        translations,
        Container,
        TextBody
      )
      setCartState(cartState)
      checkOcrSkip(res)
    } catch (err) {
      logError(err)
      setLoading(false)
      setBlockingLoading(false)
    }
  }

  const getRelatedProducts = async () => {
    try {
      setLoadingRelatedProducts(true)
      const res = await api.cart.getRelatedProducts({
        ...(isUpgrade && { params: { carttype } })
      })
      !isUpgrade &&
        setUpSell(
          res.up_sell ? mapBundleListForDisplay(res.up_sell, false) : []
        )
      setCrossSell(
        res.cross_sell ? mapProductListForDisplay(res.cross_sell, false) : []
      )
    } catch (err) {
      throw err
    } finally {
      setLoadingRelatedProducts(false)
    }
  }

  const getProductName = (
    product,
    selectedOptionIndex = product.selectedOptionIndex
  ) => {
    return (
      product &&
      product.options &&
      product.options[selectedOptionIndex].variantName
    )
  }

  const getProductId = (
    product,
    selectedOptionIndex = product.selectedOptionIndex
  ) => {
    return (
      product &&
      product.options &&
      product.options[selectedOptionIndex].variantId
    )
  }

  const getCartItem = (items, productId) => {
    return (
      items && items.find(i => i.products.find(p => p.itemId === productId))
    )
  }

  const setProductLoading = (items, id, loading) => {
    const cartItem = getCartItem(items, id)
    if (cartItem && cartItem.loading !== loading && items) {
      return items.map(el => ({
        ...el,
        loading: el === cartItem ? loading : false
      }))
    }
    return items
  }

  const updateProductQuantityInCart = (items, itemId, qty) => {
    const cartItem = getCartItem(items, itemId)
    cartItem.products[0].amount = qty
    return items.map(el => {
      return el === cartItem
        ? {
            ...cartItem
          }
        : el
    })
  }

  const handleQuantitySelectionChange = async (item, qty) => {
    const oldQty = item.amount
    try {
      let newCartItemsState = setProductLoading(cartItems, item.itemId, true)
      newCartItemsState = updateProductQuantityInCart(
        newCartItemsState,
        item.itemId,
        qty
      )
      setCartItems(newCartItemsState)
      const res = await api.cart.updateCart(
        item.id,
        qty,
        item.savedOptionVariants,
        null,
        item.chainId,
        isUpgrade ? carttype : null
      )
      updateCartCounter(res.amount)
      const cartState = buildCartState(res)
      setCartState(cartState)
      popupToast({
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error
          ? translations.tk_productNotUpdated
          : translations.tk_productQtyUpdated,
        subtitle: getProductName(item),
        content: (
          <>
            {res.free_shipping_message &&
              cartFreeShippingToastContent(res.free_shipping_message)}
            {cartToastMessageContent(getToastMessagesFromResponse(res))}
          </>
        )
      })
      analytics.updateCartQty(oldQty, qty, item)
    } catch (err) {
      let newCartItemsState = setProductLoading(cartItems, item.itemId, false)
      newCartItemsState = updateProductQuantityInCart(
        newCartItemsState,
        item.itemId,
        oldQty
      )
      setCartItems(newCartItemsState)
      const errorCode = extractErrorCode(err)
      const isPLError = isPurchaseLimitationsErrorCode(errorCode)
      if (isPLError) {
        analytics.addToCartLimitations(
          getProductId(item),
          getProductName(item),
          isCartPurchaseLimitationsErrorCode(errorCode)
        )
      }
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_productNotUpdated,
        subtitle: getProductName(item),
        content: (
          <Container>
            <TextBody
              size={TextBody.sizes.s}
              acceptsHtml
              value={getToastMessagesFromError(
                err,
                translations.tk_productUpdateImpossible
              ).join(' ')}
            />
            {isPLError && (
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(
                  translations,
                  'tk_purchaseLimitationsErrorTermsAndConditions'
                )}
              />
            )}
          </Container>
        )
      })
    }
  }

  const handleOptionSelectionChange = async (item, selectedOptionIndex) => {
    const confirmSample = item.isSample && !item.isSampleConfirmed
    try {
      const newCartItemsState = setProductLoading(cartItems, item.itemId, true)
      setCartItems(newCartItemsState)
      const res = await api.cart.updateCart(
        item.id,
        item.amount,
        item.savedOptionVariants,
        item.options[selectedOptionIndex].variantId,
        item.chainId,
        isUpgrade ? carttype : null
      )
      updateCartCounter(res.amount)
      const cartState = buildCartState(res)
      setCartState(cartState)
      popupToast({
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error
          ? translations.tk_productNotUpdated
          : confirmSample
          ? translations.tk_sampleConfirmed
          : translations.tk_productUpdated,
        subtitle: getProductName(item, selectedOptionIndex),
        content: (
          <>
            {res.free_shipping_message &&
              cartFreeShippingToastContent(res.free_shipping_message)}
            {cartToastMessageContent(getToastMessagesFromResponse(res))}
          </>
        )
      })
      getRelatedProducts()
      dispatchPopupPromotionAlreadyUsed(
        cookie.getSpiceId(),
        cartState,
        popupToast,
        translations,
        Container,
        TextBody
      )
    } catch (err) {
      const newCartItemsState = setProductLoading(cartItems, item.itemId, false)
      setCartItems(newCartItemsState)
      const errorCode = extractErrorCode(err)
      const isPLError = isPurchaseLimitationsErrorCode(errorCode)
      if (isPLError) {
        analytics.addToCartLimitations(
          getProductId(item, selectedOptionIndex),
          getProductName(item, selectedOptionIndex),
          isCartPurchaseLimitationsErrorCode(errorCode)
        )
      }
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_productNotUpdated,
        subtitle: getProductName(item, selectedOptionIndex),
        content: (
          <Container>
            <TextBody
              size={TextBody.sizes.s}
              acceptsHtml
              value={getToastMessagesFromError(
                err,
                translations.tk_productUpdateImpossible
              )}
            />
            {isPLError && (
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(
                  translations,
                  'tk_purchaseLimitationsErrorTermsAndConditions'
                )}
              />
            )}
          </Container>
        )
      })
    }
  }

  const handleSingleRemoveFromCart = async item => {
    try {
      const newCartItemsState = setProductLoading(cartItems, item.itemId, true)
      setCartItems(newCartItemsState)
      const res = await api.cart.removeFromCart(
        item.itemId,
        isUpgrade ? carttype : null
      )
      updateCartCounter(res.amount)
      const cartState = buildCartState(res)
      setCartState(cartState)
      popupToast({
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error
          ? translations.tk_productNotRemoved
          : item.isSample
          ? translations.tk_sampleUnconfirmed
          : translations.tk_productRemoved,
        subtitle: getProductName(item),
        content: (
          <>{cartToastMessageContent(getToastMessagesFromResponse(res))}</>
        )
      })
      analytics.removeFromCart(item)
    } catch (err) {
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_productNotRemoved,
        subtitle: getProductName(item),
        content: (
          <>
            {cartToastMessageContent(
              getToastMessagesFromError(
                err,
                translations.tk_productUpdateImpossible
              )
            )}
          </>
        )
      })
    }
  }

  const handleRemoveFromCart = async item => {
    await handleSingleRemoveFromCart(item)
    if (cartItems && cartItems.length > 0) {
      getRelatedProducts()
    }
  }

  const handleOnBundleClick = (bundle, index) => {
    analytics.productClickBundle(bundle, index, ANALYTICS_LIST_NAME_UPSELL)
    setModalBundle(bundle)
    setShowBundleModal(true)
  }

  const handleBundleModalClose = () => {
    setShowBundleModal(false)
  }

  const handleAddToCart = async items => {
    try {
      const res = await api.cart.addToCart(items)
      updateCartCounter(res.amount)
      analytics.addToCartBundle(modalBundle)
      const showFamilyWarning = res.familyNotice && !cookie.getFamilyWarning()
      setFamilyWarning(showFamilyWarning)
      if (showFamilyWarning) {
        cookie.setFamilyWarning(true)
        analytics.productFamilyConflict(false)
      }
      popupToast({
        disclaimer: res.promotionDisclaimer,
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error
          ? translations.tk_productAddedError
          : translations.tk_productAddedOk,
        content: (
          <>
            {res.free_shipping_message &&
              cartFreeShippingToastContent(res.free_shipping_message)}
            {cartToastMessageContent(getToastMessagesFromResponse(res))}
            {showFamilyWarning && cartToastWarningMessageContent()}
          </>
        )
      })
      setShowBundleModal(false)
      setBlockingLoading(true)
      getCart()
    } catch (err) {
      const errorCode = extractErrorCode(err)
      const isPLError = isPurchaseLimitationsErrorCode(errorCode)
      if (isPLError) {
        analytics.addToCartLimitations(
          modalBundle && modalBundle.id,
          modalBundle && modalBundle.name,
          isCartPurchaseLimitationsErrorCode(errorCode)
        )
      }
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_productAddedError,
        subtitle: modalBundle && modalBundle.name,
        content: (
          <Container>
            <TextBody
              size={TextBody.sizes.s}
              acceptsHtml
              value={getToastMessagesFromError(err)}
            />
            {isPLError && (
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(
                  translations,
                  'tk_purchaseLimitationsErrorTermsAndConditions'
                )}
              />
            )}
          </Container>
        )
      })
      setShowBundleModal(false)
    }
  }

  const handleRelatedAddToCart = async (product, selectedOptionIndex) => {
    try {
      const selectedOption = product.options[selectedOptionIndex]
      const res = await api.cart.addToCart(
        [{ id: product.id, qty: 1, option: selectedOption }],
        isUpgrade ? carttype : null
      )
      updateCartCounter(res.amount)
      const showFamilyWarning =
        !isUpgrade && res.familyNotice && !cookie.getFamilyWarning()
      setFamilyWarning(showFamilyWarning)
      if (showFamilyWarning) {
        cookie.setFamilyWarning(true)
        analytics.productFamilyConflict(false)
      }
      popupToast({
        disclaimer: res.promotionDisclaimer,
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error
          ? translations.tk_addedToCartError
          : translations.tk_addedToCart,
        subtitle: getProductName(product, selectedOptionIndex),
        content: (
          <>
            {res.free_shipping_message &&
              cartFreeShippingToastContent(res.free_shipping_message)}
            {cartToastMessageContent(getToastMessagesFromResponse(res))}
            {showFamilyWarning && cartToastWarningMessageContent()}
          </>
        )
      })
      getCart()
      getRelatedProducts()
    } catch (err) {
      const errorCode = extractErrorCode(err)
      const isPLError = isPurchaseLimitationsErrorCode(errorCode)
      if (isPLError) {
        analytics.addToCartLimitations(
          getProductId(product, selectedOptionIndex),
          getProductName(product, selectedOptionIndex),
          isCartPurchaseLimitationsErrorCode(errorCode)
        )
      }
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_addedToCartError,
        subtitle: getProductName(product, selectedOptionIndex),
        content: (
          <Container>
            <TextBody
              size={TextBody.sizes.s}
              acceptsHtml
              value={getToastMessagesFromError(err)}
            />
            {isPLError && (
              <TextBody
                size={TextBody.sizes.s}
                {...htmlTranslation(
                  translations,
                  'tk_purchaseLimitationsErrorTermsAndConditions'
                )}
              />
            )}
          </Container>
        )
      })
    }
  }

  const handleRelatedAddToPreorder = async (product, selectedOptionIndex) => {
    if (isAuthenticated()) {
      try {
        const profile = await api.profile.getProfile()
        const stockNotification = await api.cart.getStockNotification(product)
        const alreadySubscribed = checkStockNotification(
          product,
          selectedOptionIndex,
          stockNotification
        )
        if (alreadySubscribed) {
          popupToast({
            type: ToastContext.types.none,
            subtitle: translations.tk_notifyMeAlreadySubscribedTitle
          })
        } else {
          setModalNotifyMe({
            key: Math.random(),
            product: product,
            selectedOptionIndex: selectedOptionIndex,
            isAuthenticated: true,
            email: profile.EmailAddress,
            name: profile.LastName + ' ' + profile.FirstName,
            open: true
          })
        }
      } catch (err) {
        popupToast({
          type: ToastContext.types.error,
          subtitle: translations.tk_addedToPreorderError
        })
      }
    } else {
      setModalNotifyMe(modalNotifyMeState => ({
        ...modalNotifyMeState,
        key: Math.random(),
        product: product,
        selectedOptionIndex: selectedOptionIndex,
        isAuthenticated: false,
        email: undefined,
        name: undefined,
        open: true
      }))
    }
  }

  const handleOnNotifyMe = async (
    userInfo,
    product,
    selectedOptionIndex,
    recaptchaData
  ) => {
    const selectedOption = product.options[selectedOptionIndex]
    try {
      await api.cart.addStockNotification(
        userInfo,
        product.id,
        selectedOption,
        recaptchaData
      )
      return {
        success: true
      }
    } catch (err) {
      const code =
        err.data &&
        Array.isArray(err.data) &&
        err.data.length > 0 &&
        err.data[0].code
      if (
        code === constants.CAPTCHA_VALIDATION_ERROR_01 ||
        code === constants.CAPTCHA_VALIDATION_ERROR_02
      ) {
        return {
          success: false,
          captchaError: true
        }
      } else {
        resetGrecaptcha(constants.STOCK_NOTIFICATION_GRECAPTCHA_ACTION)
        popupToast({
          type: ToastContext.types.error,
          subtitle: translations.tk_addedToPreorderError
        })
        return {
          success: false,
          captchaError: false,
          error:
            err.data &&
            Array.isArray(err.data) &&
            err.data.length > 0 &&
            err.data[0].message
        }
      }
    }
  }

  const handleCouponAction = async (type, id, c) => {
    const coupon = c || (type === 'add' ? couponCode : id)
    const defaultSuccessMessage =
      type === 'add'
        ? translations.tk_couponValid
        : translations.tk_couponValidRemove
    const defaultErrorMessage =
      type === 'add'
        ? translations.tk_errorApplyingCoupon
        : translations.tk_errorRemovingCoupon
    if (!coupon) {
      return
    }
    setLoading(true)
    let res = {}
    try {
      res = await api.cart[type === 'add' ? 'addCoupon' : 'removeCoupon'](
        coupon
      )
      updateCartCounter(res.amount)
      setLoading(false)
      popupToast({
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error ? defaultErrorMessage : defaultSuccessMessage,
        subtitle:
          res.products && res.products.length > 0
            ? mapProductListForDisplay(res.products)
                .map(item => getProductName(item))
                .join(', ')
            : null,
        content: (
          <>{cartToastMessageContent(getToastMessagesFromResponse(res))}</>
        )
      })
      if (!res.warning) {
        const cartState = buildCartState(res)
        setCartState(cartState)
        setCouponCode('')
      }
      if (type === 'add') {
        let promoCouponLabel
        if (
          res.applied_promotions &&
          res.coupons &&
          res.coupons[coupon] &&
          res.coupons[coupon][0] &&
          res.applied_promotions[res.coupons[coupon][0]]
        ) {
          promoCouponLabel = `${
            res.applied_promotions[res.coupons[coupon][0]].name
          }`
        } else {
          promoCouponLabel = coupon
        }
        analytics.couponAplicationResult(
          !(res.error || res.warning),
          promoCouponLabel
        )
      }
      couponCode && setAddCouponError(!!res.error)
    } catch (err) {
      if (type === 'add') {
        analytics.couponAplicationResult(false, coupon)
      }
      setLoading(false)
      couponCode && setAddCouponError(true)
      popupToast({
        type: ToastContext.types.error,
        title: defaultErrorMessage,
        content: <>{cartToastMessageContent(getToastMessagesFromError(err))}</>
      })
    }
  }

  const handleCouponChangeInput = e => {
    const value = e.target.value
    setCouponCode(value)
    addCouponError && setAddCouponError(false)
  }

  const checkLoyaltyCoupons = () => {
    // check if we have eligible coupons of loyalty type
    const loyaltyEligibleCoupons =
      eligibleCoupons.filter(eCoupon => eCoupon.loyaltyType).length >= 1
    // check if we are using coupons of loyalty type
    const loyaltyUsedCoupons =
      coupons.filter(coupon => coupon.loyaltyType).length >= 1

    // dispatch popup if we have eligible coupons of loyalty type and they are not in use
    return loyaltyEligibleCoupons && !loyaltyUsedCoupons
  }

  const handleCartValidation = () => {
    const dispatchLoyaltyPopup = !isUpgrade && checkLoyaltyCoupons()
    if (dispatchLoyaltyPopup) {
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_loyaltyCouponsNotUsed,
        actions: [
          <Button
            key={0}
            variant={Button.variants.secondary}
            text={translations.tk_proceedWithoutApply}
            onClickHandler={() => {
              goTo(Routes.checkout)
            }}
          />
        ]
      })
    } else {
      const products = [].concat.apply(
        [],
        cartItems.map(item => item.products)
      )
      const displaySampleAlert =
        products.filter(el => el.isSample && !el.isSampleConfirmed).length > 0
      if (!sampleSelectionAlertTriggered && displaySampleAlert) {
        popupToast({
          title: translations.tk_toastFreeSampleTitle,
          subtitle: translations.tk_toastFreeSampleSubtitle,
          actions: cartToastSampleSelectionAlertActions()
        })
        analytics.samplingCart(
          'Display',
          'Post - Pop-up – Sample selection error'
        )
        setSampleSelectionAlertTriggered(true)
      } else {
        isUpgrade && cookie.setUpgradeFlowFlag(true)
        goTo(!isUpgrade ? Routes.checkout : Routes.upgradeOfferCheckout, true)
      }
    }
  }

  const scrollToContainer = () => {
    setTimeout(() => {
      scroller.scrollTo(couponSection, {
        duration: 0,
        smooth: true
      })
    }, 100)
  }

  const handleApplyEligibleCoupon = async coupon => {
    setLoading(true)
    let res = {}
    try {
      res = await api.cart.addCoupon(coupon.code)
      scrollToContainer()
      setLoading(false)
      popupToast({
        type: res.error ? ToastContext.types.error : ToastContext.types.success,
        title: res.error
          ? translations.tk_errorApplyingCoupon
          : translations.tk_couponValid,
        subtitle:
          res.products && res.products.length > 0
            ? mapProductListForDisplay(res.products)
                .map(item => getProductName(item))
                .join(', ')
            : null,
        content: (
          <>
            {res.free_shipping_message &&
              cartFreeShippingToastContent(res.free_shipping_message)}
            {cartToastMessageContent(getToastMessagesFromResponse(res))}
          </>
        )
      })
      if (!res.warning) {
        const cartState = buildCartState(res)
        setCartState(cartState)
      }
      analytics.couponAplicationResult(
        !(res.error || res.warning),
        `${coupon.name}`
      )
    } catch (err) {
      analytics.couponAplicationResult(false, `${coupon.name}`)
      setLoading(false)
      popupToast({
        type: ToastContext.types.error,
        title: translations.tk_errorApplyingCoupon,
        content: <>{cartToastMessageContent(getToastMessagesFromError(err))}</>
      })
    }
  }

  const handleSummaryVisibility = isVisible => {
    setStickySummaryVisible(!isVisible)
  }

  const handleSummaryLayoutUpdate = () => {
    const stickySummaryLayoutValue = getStickySummaryLayout()
    if (
      stickySummaryLayoutValue &&
      (stickySummaryLayoutValue.height !== stickySummaryLayout.height ||
        stickySummaryLayoutValue.top !== stickySummaryLayout.top)
    ) {
      setStickySummaryLayout({ ...stickySummaryLayoutValue })
    }
  }

  const getStickySummaryLayout = () => {
    let refTopBlock
    if (isUpgrade) {
      const container = document.getElementById(componentContainerId)
      const parent = getStickTopEl(getStickTopEl(getStickTopEl(container)))
      refTopBlock = parent ? parent.offsetTop - 1 : 0
    } else {
      const backButtonContainer = document.getElementById(backButtonBlockId)
      refTopBlock = backButtonContainer
        ? backButtonContainer.offsetTop + backButtonContainer.clientHeight
        : 0
    }
    const stickySummaryEl = document.getElementById(stickySummaryElementId)
    return {
      top: refTopBlock,
      height: stickySummaryEl ? stickySummaryEl.clientHeight : 0
    }
  }

  const getStickTopEl = el => {
    return el ? el.parentElement : el
  }

  const cartToastActions = () => {
    return [
      <Button
        key={0}
        variant={Button.variants.primary}
        text={translations.tk_toastProceedToLogin}
        onClickHandler={() => {
          goTo(Routes.userLogin, false, false, [
            `callredirectUrl=${Routes.cart}`
          ])
        }}
      />
    ]
  }

  const cartFreeShippingToastContent = msg => {
    return (
      <Container display={Container.displays.flex} pb="2">
        <Container pr="2">
          <Icon size={Icon.sizes.s} image={Icon.images.orders} />
        </Container>
        <TextBody size={TextBody.sizes.s} acceptsHtml value={msg} />
      </Container>
    )
  }

  const cartToastMessageContent = msg => {
    return <TextBody size={TextBody.sizes.s} acceptsHtml value={msg} />
  }

  const cartToastWarningMessageContent = () => {
    return (
      <TextBody
        darkMode
        style={TextBody.styles.error}
        {...htmlTranslation(translations, 'tk_addedToCartFamilyNotice')}
      />
    )
  }

  const continueShopping = () => {
    familyWarning && analytics.productFamilyConflictDecision(false)
    analytics.samplingCart('Click', 'Post - Pop-up - Continue shopping')
    dismissToast()
  }

  const proceedToCheckout = () => {
    isUpgrade && cookie.setUpgradeFlowFlag(true)
    familyWarning && analytics.productFamilyConflictDecision(true)
    analytics.samplingCart('Click', 'Post - Pop-up - Proceed checkout')
    goTo(!isUpgrade ? Routes.checkout : Routes.upgradeOfferCheckout, true)
  }

  const cartToastSampleSelectionAlertActions = () => {
    return [
      <Button
        key={0}
        variant={Button.variants.secondary}
        text={translations.tk_toastFreeSampleSelectSample}
        onClickHandler={continueShopping}
        data-testing="Cart_Button_KeepShopping"
      />,
      <Button
        key={1}
        variant={Button.variants.primary}
        text={translations.tk_toastFreeSampleProceedToCheckout}
        onClickHandler={proceedToCheckout}
        data-testing="Cart_Button_GoToCheckout"
      />
    ]
  }

  const cartSummaryProps = {
    isAuthenticated: isAuthenticated(),
    subtotal,
    total,
    hasDiscount,
    discount,
    discountFlat,
    delivery,
    deliveryFlat,
    isCheckoutDisabled: cartItems.length === 0,
    familyNotice,
    translations,
    promotions,
    coupons,
    couponCode,
    hideCoupon,
    tva: tvaStatus,
    handleCouponAction: handleCouponAction,
    handleCouponChangeInput: handleCouponChangeInput,
    handleCartValidation: handleCartValidation,
    eligibleCoupons: eligibleCoupons,
    handleApplyEligibleCoupon: handleApplyEligibleCoupon,
    addCouponError: addCouponError
  }

  return (
    <>
      {loading || cartItems.length === 0 ? (
        <>
          {loading ? (
            <Container position={Container.positions.relative} height="96">
              <BlockingLoader loading />
            </Container>
          ) : (
            <Container
              pt={['8', '8', '12']}
              pb={['8', '8', '20']}
              px={['8', '8', '16']}>
              <TextCaption size={TextCaption.sizes.m}>
                {translations.tk_emptyCartPageTitle}
              </TextCaption>
              <Container
                display={Container.displays.flex}
                alignItems={Container.alignItemsValues.center}
                justifyContent={Container.justifyContentValues.center}
                flexDirection={Container.flexDirections.column}>
                <Container pt={['10', '10', '12']} pb="4">
                  <Icon64 size={Icon64.sizes.m} image={Icon64.images.orders} />
                </Container>
                <Container pb="10">
                  <TextBody
                    {...htmlTranslation(translations, 'tk_emptyCartMessage')}
                  />
                </Container>
                <Container>
                  <Button
                    onClickHandler={() => {
                      line
                        ? canUseDOM && window.liff && window.liff.closeWindow()
                        : goTo(translations.tk_goToShopPageUrl)
                    }}
                    text={
                      line
                        ? translations.tk_closeEmptyCartPageButton
                        : translations.tk_goToShopPageButton
                    }
                    variant={Button.variants.primary}
                    data-testing="Cart_Button_GoToShopPage"
                  />
                </Container>
              </Container>
            </Container>
          )}
        </>
      ) : (
        <Container
          display={Container.displays.flex}
          flexWrap
          pt={['8', '8', '12']}
          pb={['8', '8', '20']}
          id={componentContainerId}>
          {!line && (
            <Container
              display={[
                Container.displays.block,
                Container.displays.block,
                Container.displays.none
              ]}>
              <Css
                s={{
                  position: 'fixed',
                  top: stickySummaryLayout.top,
                  left: '0',
                  width: '100%',
                  zIndex: '20'
                }}>
                <Sticky zIndex="10" fullWidth followNavBar={true} l="0" t="0">
                  <Css
                    s={{
                      position: 'absolute',
                      width: '100%',
                      transition: 'all 500ms ease-in-out',
                      top: stickySummaryVisible
                        ? 0
                        : -(stickySummaryLayout.height + 75)
                    }}>
                    <Container id={stickySummaryElementId} fullWidth shadow>
                      <CartSummary
                        {...cartSummaryProps}
                        compact
                        handleSummaryLayoutUpdate={handleSummaryLayoutUpdate}
                      />
                    </Container>
                  </Css>
                </Sticky>
              </Css>
            </Container>
          )}
          <Container
            width={['full', 'full', '8/12']}
            pl={['8', '8', '16']}
            pr="8">
            <Container pb={['4', '10']}>
              <Css
                s={{
                  paddingTop: stickySummaryVisible
                    ? stickySummaryLayout.height
                    : 0
                }}>
                {!isAuthenticated() && isMobile().any && (
                  <Container pb="10">
                    <CartCheckoutGuestActions
                      translations={translations}
                      topButtons
                    />
                  </Container>
                )}
                <TextTitle heading={TextTitle.headings.h4}>
                  {translations.tk_shoppingCart}
                </TextTitle>
              </Css>
            </Container>
            <Container pb="6">
              <TextBody data-testing="Cart_TextBody_TotalItems">
                {`${translations.tk_totalItems} ${totalItems}`}
              </TextBody>
            </Container>
            <Container>
              {cartItems
                .filter(
                  item =>
                    item.products.filter(product => !product.isLogistics)
                      .length > 0
                )
                .map((item, index) => {
                  return (
                    <CartItem
                      translations={translations}
                      key={index}
                      index={index}
                      amount={cartItems.length}
                      item={item}
                      handleQuantitySelectionChange={
                        !isUpgrade || index > 0
                          ? handleQuantitySelectionChange
                          : null
                      }
                      handleOptionSelectionChange={handleOptionSelectionChange}
                      handleRemoveFromCart={
                        !isUpgrade || index > 0 ? handleRemoveFromCart : null
                      }
                      noDetailLink={isUpgrade || item.products[0].isSample}
                      showFamily={!isUpgrade}
                    />
                  )
                })}
              {noAuthFreeSampleMessage && (
                <Container py={['8', '10']}>
                  <Container p={['6', '8']} bg="hardWhite">
                    <TextBody acceptsHtml value={noAuthFreeSampleMessage} />
                  </Container>
                </Container>
              )}
            </Container>
          </Container>
          <VisibilitySensor
            offset={{
              top: stickySummaryVisible ? 0 : -(stickySummaryLayout.height + 75)
            }}
            partialVisibility
            resizeCheck
            minTopValue={36}
            onChange={handleSummaryVisibility}>
            <Container width={['full', 'full', '4/12']} pr={['0', '0', '16']}>
              <CartSummary {...cartSummaryProps} />
            </Container>
          </VisibilitySensor>
          {!line ? (
            loadingRelatedProducts ? (
              <Container fullWidth pt="12" px={['8', '8', '16']}>
                <Container
                  fullWidth
                  p="10"
                  position={Container.positions.relative}>
                  <BlockingLoader loading />
                </Container>
              </Container>
            ) : (
              <Container fullWidth px={['8', '8', '16']}>
                {crossSell && crossSell.length > 0 && (
                  <ProductListCrossSell
                    products={crossSell}
                    translations={translations}
                    onAddToCart={handleRelatedAddToCart}
                    onAddToPreorder={handleRelatedAddToPreorder}
                  />
                )}
                {upSell && upSell.length > 0 && (
                  <ProductListUpSell
                    products={upSell}
                    onAddToCart={handleOnBundleClick}
                    translations={translations}
                    buttonAddToCartLabel={translations.tk_selectAnOption}
                    bundleDetailPath={bundleDetailPath}
                  />
                )}
              </Container>
            )
          ) : null}
          <BlockingLoader loading={blockingLoading} fullScreen />
          <ProductBundleModal
            bundle={modalBundle}
            handleAddToCart={handleAddToCart}
            isOpen={showBundleModal}
            onCloseHandler={handleBundleModalClose}
            translations={translations}
            bundleDetailPath={bundleDetailPath}
          />
          <ModalNotifyMe
            key={modalNotifyMe.key}
            isAuthenticated={modalNotifyMe.isAuthenticated}
            defaultEmail={modalNotifyMe.email}
            defaultName={modalNotifyMe.name}
            translations={translations}
            isOpen={modalNotifyMe.open}
            product={modalNotifyMe.product}
            selectedOptionIndex={modalNotifyMe.selectedOptionIndex}
            handleOnNotifyMe={handleOnNotifyMe}
            onClose={() => {
              setModalNotifyMe(modalNotifyMeState => ({
                ...modalNotifyMeState,
                open: false
              }))
            }}
          />
        </Container>
      )}
    </>
  )
}

const Cart = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={CartComponent}
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...CartTranslations,
  ...CommonTranslations
}

const ComponentDefaultProps = {
  componentName: 'Cart',
  cartItems: [],
  translations: {
    ...parseTranslations(ComponentTranslations, true)
  }
}

Cart.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    line: !!req?.query?.line,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: () => {
      const backButtonBlockId =
        (req.body.extra && req.body.extra.backButtonId) || ''
      const isUpgrade = req && req.query && req.query.isUpgrade === 'true'
      const bundleDetailPath =
        (req.body.extra && req.body.extra.bundle_detail_path) || ''
      return {
        backButtonBlockId,
        isUpgrade,
        bundleDetailPath
      }
    }
  })
}

export default Cart
